import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ItemGroupEmptyIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M21 5.25H11.54C11.46 5.25 11.38 5.21 11.33 5.14L10.22 3.48C9.71 2.71 8.85 2.25 7.93 2.25H3C2.04 2.25 1.25 3.04 1.25 4V20C1.25 20.96 2.04 21.75 3 21.75H21C21.96 21.75 22.75 20.96 22.75 20V7C22.75 6.04 21.96 5.25 21 5.25ZM21.25 20C21.25 20.14 21.14 20.25 21 20.25H3C2.86 20.25 2.75 20.14 2.75 20V4C2.75 3.86 2.86 3.75 3 3.75H7.93C8.35 3.75 8.74 3.96 8.97 4.31L10.08 5.97C10.4 6.46 10.95 6.75 11.54 6.75H21C21.14 6.75 21.25 6.86 21.25 7V20Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ItemGroupEmptyIcon.displayName = 'ItemGroupEmptyIcon';
